/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Directive, ElementRef, AfterViewInit, Input, OnDestroy } from '@angular/core';
import { Rectangle } from 'pixi.js-legacy';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PositionManagerService } from 'src/app/services/position-manager.service';

@Directive({
	selector: '[positionTracker]',
})
export class PositionTrackerDirective implements AfterViewInit, OnDestroy {
	@Input() public callback: (ptd: PositionTrackerDirective) => void;

	private destroy$ = new Subject<void>();

	constructor(private element: ElementRef, private positionManagerService: PositionManagerService) {}

	public ngAfterViewInit(): void {
		// Report the current position:
		this.reportPosition();

		// Listen for window resizing and report again then:
		fromEvent(window, 'resize')
			.pipe(takeUntil(this.destroy$))
			.subscribe((event) => {
				this.reportPosition();
			});

		// Gasp.  The dreaded...
		if (this.callback) {
			this.callback(this);
		}
	}

	public reportPosition(): void {
		const target: HTMLElement = this.element.nativeElement.children[0];
		const rect: ClientRect = target.getBoundingClientRect();
		const width: number = target.offsetWidth;
		const height: number = target.offsetHeight;
		const x: number = rect.left;
		const y: number = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) - height; // rect.top gives inconsistently incorrect value
		const type: string = this.element.nativeElement.nodeName;
		this.positionManagerService.setPosition(type, new Rectangle(x, y, width, height));
	}

	public ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
